import { QueryClient, QueryClientConfig } from '@tanstack/react-query';
import {
	Persister,
	persistQueryClient,
} from '@tanstack/react-query-persist-client';

export const createQueryClient = (
	config?: QueryClientConfig,
	persister?: Persister,
	onlineSubscription?: (setOnline: (isOnline: boolean) => void) => void
) => {
	const defaultConfig = {
		...config,
		defaultOptions: {
			...config?.defaultOptions,
			queries: {
				refetchOnWindowFocus: false,
				retryOnMount: false,
				refetchOnReconnect: true,
				retry: false,
				gcTime: 1000 * 60 * 2, // 2 minutes (renamed from cacheTime in v5)
				...config?.defaultOptions?.queries,
			},
		},
	};

	const queryClient = new QueryClient({
		...defaultConfig,
	});

	if (persister) {
		try {
			persistQueryClient({
				queryClient,
				persister,
			});
		} catch (error) {
			console.error('Failed to set up query client persistence:', error);
			// Continue without persistence rather than crashing
		}
	}

	const handleOfflineModeForQueries = (isOnline: boolean) => {
		queryClient.setDefaultOptions({
			queries: {
				...defaultConfig.defaultOptions.queries,
				...(!isOnline && {
					gcTime: 1000 * 60 * 60 * 24, // 24 hours (renamed from cacheTime in v5)
				}),
				staleTime: !isOnline ? Infinity : 0,
			},
		});
	};

	onlineSubscription?.(handleOfflineModeForQueries);

	return queryClient;
};
